module.exports = __webpack_public_path__ + "media/images/linkedin2x-a8e48a17579a01e10276baee2d45854d.png";